import React, { useEffect, useState } from "react";
import Layout from "../components/layout";
import { useParams, useNavigate } from "react-router-dom";
import { Form, Input, Row, Col, Select, Tabs, Upload, Button } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import toast from "react-hot-toast";
import axios from "axios";
import userPicPlaceholder from "../components/people.jpg";
import { useSelector } from "react-redux";

import "../index.css";
const { TabPane } = Tabs;
const { Option } = Select;
const { TextArea } = Input;

const UserDetail = () => {
  const { user_id } = useParams();
  // console.log("user id from useparam: ", user_id);
  const [userData, setUserData] = useState(null);
  const [email, setEmail] = useState("");
  const [accountType, setAccountType] = useState("");
  const [accountStatus, setAccountStatus] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [history, setHistory] = useState([]);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [matchStatus, setMatchStatus] = useState(undefined);

  const navigate = useNavigate();

  // Get admin status from Redux store
  const isAdmin = useSelector((state) => state.user.user?.type === "Admin");
  const isAfl = useSelector((state) => state.user.user?.type === "Afl");

  // const renderSeparator = () => (
  //   <React.Fragment>
  //     <hr style={{ margin: "5px 0", height: "5px" }} />
  //   </React.Fragment>
  // );

  const handleUpdateUser = async () => {
    try {
      const updateUser = {
        email,
        isAdmin: accountType,
        isactive: accountStatus,
      };
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/auth/update-user/${user_id}`,
        updateUser,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      const responseData = response.data;
      if (responseData.success) {
        toast.success(responseData.message);
        navigate(`/user-detail/${user_id}`);
        window.location.reload();
      }
    } catch (error) {
      console.error("Error updating user:", error);
      toast.error("Failed to update user");
    }
  };

  const handlePasswordChange = async (values) => {
    try {
      const { password } = values;
      console.log("NEW PASSWORD :", password);
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/auth/update-password/${user_id}`,
        { password },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      const responseData = response.data;
      if (responseData.success) {
        toast.success(responseData.message);
      }
    } catch (error) {
      console.error("Error updating user:", error);
      toast.error("Failed to update user");
    }
  };

  useEffect(() => {
    // retrieve user info
    console.log("user id", user_id);
    const fetchUser = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/auth/user-detail/${user_id}`,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
              "Content-Type": "application/json", // Specify content type
            },
            method: "GET",
          }
        );

        const parseRes = await response.json();
        if (parseRes.success === true) {
          const { email, accountType, accountStatus } = parseRes.data;
          setEmail(email);
          setAccountType(accountType);
          setAccountStatus(accountStatus);
          setUserData(parseRes.data);

          console.log("the data", parseRes.data); // Log the retrieved data

          //   console.log("nom dependant: ", parseRes.data.dependant);
        } else {
          console.log("user not recognized");
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };
    fetchUser();
  }, [user_id]);

  useEffect(() => {
    // user history on the second tab
    const getHistory = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/auth/user-history/${user_id}`,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
            method: "POST",
          }
        );

        const historyData = await response.json();

        if (historyData.success) {
          console.log("historyData: ", historyData);
          setHistory(historyData.Result); // Ensure to set the actual array
        }
      } catch (error) {
        console.error("Error fetching history:", error);
      }
    };

    getHistory();
  }, []);

  if (!userData) {
    return <div>Loading...</div>;
  }

  return (
    <Layout>
      <div className="px-5 mt-3">
        <div className="d-flex justify-content-center">
          <h3 className="d-flex justify-content-center page-title">
            Informations Utilisateur
          </h3>
        </div>
        <Tabs defaultActiveKey="1">
          <TabPane tab="Details" key="1">
            <Row gutter={25}>
              <Col span={12} style={{ marginLeft: "80px" }}>
                <div className="user-detail-container">
                  <div key={userData.matricule} className="row">
                    <div className="col-md-2">
                      {userData.photo ? (
                        <p>
                          <img
                            src={
                              `http://localhost:3000/Images/Users/` +
                              userData?.photo
                            }
                            className="user_photo_detail"
                            alt=""
                          />
                        </p>
                      ) : (
                        <p>
                          <img
                            src={userPicPlaceholder}
                            className="user_photo_detail"
                            alt=""
                          />
                        </p>
                      )}
                    </div>
                  </div>

                  <div>
                    <p className="member-detail-name">
                      {userData.prenom}
                      <br />
                      <span style={{ textTransform: "uppercase" }}>
                        {userData.nom}
                      </span>
                    </p>
                  </div>
                  <div>
                    <p className="text-left-value">
                      <span className="user-text-left-title">Email: </span>
                      {userData.email}
                    </p>
                  </div>
                  <div>
                    <p className="text-left-value">
                      <span className="user-account-type">
                        Type de Compte:{" "}
                      </span>
                      {userData.type === "Admin"
                        ? "Administrateur"
                        : userData.type === "User"
                        ? "Utilisateur"
                        : userData.type === "Afl"
                        ? "Entreprise Affiliée"
                        : ""}
                    </p>
                  </div>
                  <div>
                    <p className="text-left-value">
                      <span className="user-text-left-title">Entreprise: </span>
                      {userData.societe}
                    </p>
                  </div>
                  <div>
                    <p className="text-left-value">
                      <span className="user-text-left-title">Statut: </span>
                      {userData.isactive ? "Actif" : "Inactif"}
                    </p>
                  </div>
                  <div>
                    <p className="text-left-value">
                      <span className="user-text-left-title">Crée le: </span>
                      {new Date(userData.created_at).toLocaleString()}
                    </p>
                  </div>
                </div>
              </Col>

              {isAdmin && (
                <Col span={5}>
                  {/* Admin edit form */}
                  <div className="user-update-container">
                    <h1 className="page-subtitle">Modifier Information</h1>
                    <hr />
                    <Form
                      layout="vertical"
                      encType="multipart/form-data"
                      onFinish={handleUpdateUser}
                    >
                      <Row gutter={25}>
                        <Col span={24}>
                          <Form.Item
                            label="Choisir le type de compte (Admin, Utilisateur, Afl)"
                            rules={[
                              {
                                required: true,
                                message:
                                  "Please select account type (admin/user/afl)",
                              },
                            ]}
                          >
                            <Select
                              placeholder="type de compte"
                              value={accountType}
                              onChange={(value) => setAccountType(value)}
                            >
                              <Option value="Admin">Admin</Option>
                              <Option value="User">Utilisateur</Option>
                              <Option value="Afl">Affilié</Option>
                            </Select>
                          </Form.Item>
                        </Col>

                        <Col span={24}>
                          <Form.Item
                            label="Email"
                            rules={[
                              {
                                required: true,
                                message: "Please enter email",
                              },
                            ]}
                          >
                            <Input
                              type="email"
                              placeholder="Enter Email Address"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={24}>
                          <Form.Item
                            label="Statut du compte"
                            rules={[
                              {
                                required: true,
                                message:
                                  "Select account Status (Active/Inactive)",
                              },
                            ]}
                          >
                            <Select
                              placeholder="Select account status"
                              value={accountStatus}
                              onChange={(value) => setAccountStatus(value)}
                            >
                              <Option value="true">Actif</Option>
                              <Option value="false">Inactif</Option>
                            </Select>
                          </Form.Item>
                        </Col>

                        <Col span={24}>
                          <Form.Item label="Nouveau mot de passe">
                            <Input.Password
                              value={newPassword}
                              onChange={(e) => setNewPassword(e.target.value)}
                              placeholder="Laisser vide pour ne pas changer"
                            />
                          </Form.Item>
                        </Col>
                      </Row>

                      <button className="btn btn-primary" type="submit">
                        Confirmer
                      </button>
                    </Form>
                  </div>
                </Col>
              )}

              {isAfl && (
                <Col span={5}>
                  <div className="user-send-message-container">
                    <h1 className="page-subtitle">Modifier mon mot de passe</h1>
                    <hr />
                    <Form
                      layout="vertical"
                      onFinish={handlePasswordChange}
                      onValuesChange={(
                        { password, confirmPassword },
                        allValues
                      ) => {
                        const pwd = allValues.password;
                        const conf = allValues.confirmPassword;
                        setMatchStatus(pwd && conf && pwd === conf);
                      }}
                    >
                      <Form.Item
                        hasFeedback
                        validateStatus={
                          matchStatus === undefined
                            ? ""
                            : matchStatus
                            ? "success"
                            : "error"
                        }
                        name="password"
                        label="Nouveau mot de passe"
                        rules={[
                          {
                            required: true,
                            message:
                              "Veuillez entrer votre nouveau mot de passe",
                          },
                        ]}
                      >
                        <Input.Password placeholder="Entrez votre nouveau mot de passe" />
                      </Form.Item>

                      <Form.Item
                        hasFeedback
                        validateStatus={
                          matchStatus === undefined
                            ? ""
                            : matchStatus
                            ? "success"
                            : "error"
                        }
                        name="confirmPassword"
                        label="Confirmer mot de passe"
                        dependencies={["password"]}
                        rules={[
                          {
                            required: true,
                            message:
                              "Veuillez confirmer votre nouveau mot de passe",
                          },
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              if (
                                !value ||
                                getFieldValue("password") === value
                              ) {
                                return Promise.resolve();
                              }
                              return Promise.reject(
                                new Error(
                                  "Les mots de passe ne correspondent pas"
                                )
                              );
                            },
                          }),
                        ]}
                        help={
                          matchStatus === undefined ? null : matchStatus ? (
                            <span style={{ color: "green" }}></span>
                          ) : (
                            "Les mots de passe ne correspondent pas"
                          )
                        }
                      >
                        <Input.Password placeholder="Confirmer votre nouveau mot de passe" />
                      </Form.Item>

                      <button
                        className="btn btn-primary send-button"
                        type="submit"
                      >
                        Confirmer
                      </button>
                    </Form>
                  </div>
                </Col>
              )}
            </Row>
          </TabPane>

          <TabPane tab="historique" key="2">
            <div className="px-5 mt-3">
              <div className="mt-3">
                <table className="table mt-3">
                  <thead>
                    <tr>
                      <th className="category">Catégorie</th>
                      <th className="category">Date</th>
                      <th className="category">Société</th>
                      <th className="category">Adresse</th>
                      <th className="category">Utilisateur</th>
                    </tr>
                  </thead>
                  <tbody>
                    {history.map((e, index) => (
                      <tr key={index}>
                        <td>{e.category}</td>
                        <td>{new Date(e.created_at).toLocaleString()}</td>
                        <td>{e.societe}</td>
                        <td>{e.adresse}</td>
                        <td>{e.prise_en_charge_noms}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </TabPane>
        </Tabs>
      </div>
    </Layout>
  );
};

export default UserDetail;
